import React from "react";

const ServicesSolutions = () => {
  return (
    <div className="py-10 services_solution lg:py-16 xl:py-20">
      <div className="container px-4 mx-auto">
        <div className="grid grid-cols-12 gap-5">
          <div className="col-span-12 text-center lg:col-start-3 lg:col-end-11">
            <h2 className="text-[28px] leading-[39px] text-black mb-8">
              Cool Solutions for Warm Relations with Our Landlords Begins with
              Pynguin's Top Tier Property Management Services
            </h2>
            <p>
              Welcome to Pynguin Property Management, where exceptional service
              meets the unique charm of Florida's real estate. From tenant
              screening to maintenance, and financial reporting to legal
              compliance, our services are designed to handle every aspect of
              property management with precision and care. Trust us to be your
              cool-headed partner in navigating the dynamic world of Florida
              property management.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicesSolutions;
